module.exports = __webpack_public_path__ + "img/3.92e1d72f.png";